module.exports = __webpack_public_path__ + "static/img/6.4f42928.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/6.png
// module id = boIe
// module chunks = 0